<template>
  <div v-if="data">
    <div class="cardContainer evaluationHeader" style="padding: 30px">
      <h5 class="medium-title" style="margin-bottom: 20px;">
        {{ $t("label_evaluation_opportunitiesImprovement_title") }}
      </h5>
      <div>
        {{ $t("label_evaluation_opportunitiesImprovement_descriptionMain") }}
      </div>
      <b-button
        variant="primary"
        style="margin: 30px 0"
        @click="setNewImpovement()"
      >
        {{ $t("label_evaluation_opportunitiesImprovement_title") }}
      </b-button>
      <div v-if="data.improvements">
        <div v-for="(improvementE, index) in data.improvements" :key="index">
          <div
            class="h7"
            @click.prevent.stop="setImprovementDetails(improvementE)"
          >
            <i
              class="vtl-icon"
              :class="caretClass(improvementE.details)"
              @click.prevent.stop="setImprovementDetails(improvementE)"
            />
            {{ improvementE.evaluation_opportunitiesImprovement_askForTitle }}
            <span style="cursor: pointer" @click="setEdit(index)"
              ><img
                src="../../../../assets/images/edit_icon.svg"
                style="width: 20px; height: 20px"
            /></span>
          </div>
          <div style="padding-left: 35px">
            <div
              v-if="improvementE.details === true"
              style="
                margin-bottom: 20px;
                border-bottom: 1px solid rgb(99, 99, 99);
                padding-bottom: 20px;
              "
            >
              <div class="h7">
                {{
                  $t("label_evaluation_opportunitiesImprovement_whatWasFound")
                }}
              </div>
              <div>
                {{
                  improvementE.evaluation_opportunitiesImprovement_whatWasFound
                }}
              </div>
              <div class="h7">
                {{
                  $t("label_evaluation_opportunitiesImprovement_whereWasFound")
                }}
              </div>
              <div>
                {{
                  improvementE.evaluation_opportunitiesImprovement_whereWasFound
                }}
              </div>
              <div class="h7">
                {{
                  $t(
                    "label_evaluation_opportunitiesImprovement_affectedRequirements"
                  )
                }}
              </div>
              <div>
                <div
                  v-for="(req, reqIndex) in improvementE.nodesToImprove"
                  :key="reqIndex"
                >
                  {{ req.evaluation_administrator_node_nomenclature }}
                  {{ req.evaluation_administrator_node_requirementName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modalInfo"
      v-model="newImprovement"
      size="xl"
      class="modal-improvements modalInfo"
      style="padding: 30px"
    >
      <div style="padding: 20px">
        <h5 style="margin-bottom: 20px">
          {{ $t("label_evaluation_opportunitiesImprovement_title") }}
        </h5>
        <div>
          {{ $t("label_evaluation_opportunitiesImprovement_description") }}
        </div>
        <b-form-group label-class="text-sm-left">
          <template slot="label">
            <!--title-->
            {{ $t("label_evaluation_opportunitiesImprovement_askForTitle") }}
          </template>
          <b-form-input
            id="label_evaluation_opportunitiesImprovement_askForTitle"
            v-model="
              improvement.evaluation_opportunitiesImprovement_askForTitle
            "
            type="text"
            required
          />
          <form-error
            :errors="errors['evaluation_opportunitiesImprovement_askForTitle']"
            :field-name="'evaluation_opportunitiesImprovement_askForTitle'"
          />
        </b-form-group>
        <b-form-group label-class="text-sm-left">
          <template slot="label">
            <!--title-->
            {{ $t("label_evaluation_opportunitiesImprovement_whatWasFound") }}
          </template>
          <b-input-group>
            <b-textarea
              id="label_evaluation_opportunitiesImprovement_whatWasFound"
              v-model="
                improvement.evaluation_opportunitiesImprovement_whatWasFound
              "
            />
          </b-input-group>
          <form-error
            :errors="errors['evaluation_opportunitiesImprovement_whatWasFound']"
            :field-name="'evaluation_opportunitiesImprovement_whatWasFound'"
          />
        </b-form-group>
        <b-form-group label-class="text-sm-left">
          <template slot="label">
            <!--title-->
            {{ $t("label_evaluation_opportunitiesImprovement_whereWasFound") }}
            <template-tooltip
              tooltip="label_evaluation_opportunitiesImprovement_whatWasFound_tooltip"
            />
          </template>
          <b-input-group>
            <b-textarea
              id="label_evaluation_opportunitiesImprovement_whereWasFound"
              v-model="
                improvement.evaluation_opportunitiesImprovement_whereWasFound
              "
            />
          </b-input-group>
          <form-error
            :errors="errors['evaluation_opportunitiesImprovement_whereWasFound']"
            :field-name="'evaluation_opportunitiesImprovement_whereWasFound'"
          />
        </b-form-group>
        <div>
          {{
            $t("label_evaluation_opportunitiesImprovement_affectedRequirements")
          }}
        </div>
        <div>
          {{
            $t(
              "label_evaluation_opportunitiesImprovement_affectedRequirements_description"
            )
          }}
        </div>
        <div style="padding-left: 15px">
          <evaluation-improvements-tree-list
            :draggable="false"
            :model="data"
            default-tree-node-name="new node"
            :account="account"
            :default-expanded="false"
            default-leaf-node-name="new leaf"
            :selected-nodes="improvement.nodesToImprove"
            @drop-before="treeSelection"
            @dataChanged="treeSelection"
          />
          <form-error
            :errors="errors['nodesToImprove']"
            :field-name="'nodesToImprove'"
          />
        </div>

        <!--          <b-button variant="primary"
          @click="setNewImpovement()" >
  {{$t('label_evaluation_requirementEvaluation_back')}}
</b-button >-->
      </div>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-button variant="primary" @click="saveImprovement()">
          {{ $t("label_evaluation_requirementEvaluation_post_button") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import EvaluationImprovementsTreeList from "./EvaluationImprovementsTreeList.vue";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";
import FormError from "./../../../template/_template-error.vue";

export default {
  name: "EvaluationImprovementTab",
  components: { EvaluationImprovementsTreeList, FormError },
  props: ["account"],
  data() {
    return {
      indexImprovement: -1,
      nodesToImprove: [],
      newImprovement: false,
      improvement: {},
      data: null,
      errors:{}
    };
  },
  mounted() {
    if (this.getSelectedEvaluation && this.getSelectedEvaluation.evaluation) {
      this.data = cloneDeep(this.getSelectedEvaluation.evaluation);
    }
  },
  computed: {
    ...mapGetters(["getSelectedEvaluation"]),
  },
  watch: {
    getSelectedEvaluation: function () {
      this.data = cloneDeep(this.getSelectedEvaluation.evaluation);
    },
  },
  methods: {
    caretClass(expanded) {
      return expanded ? "vtl-icon-caret-down" : "vtl-icon-caret-right";
    },
    setEdit(index) {
      this.indexImprovement = index;
      this.improvement = { ...this.data.improvements[index] };
      this.newImprovement = true;
    },
    setNewImpovement() {
      const tree = this.getNewTree();
      this.removeAllSelected(tree);
      this.$emit("update:data", tree);
      this.improvement = { ...{} };
      this.indexImprovement = -1;
      this.nodesToImprove = [...[]];
      this.newImprovement = true;
    },
    hasRequiredFields() {
      this.errors = {};
      if (!this.improvement.evaluation_opportunitiesImprovement_askForTitle) {
        this.errors["evaluation_opportunitiesImprovement_askForTitle"] = ["required"];
      }
      if (!this.improvement.evaluation_opportunitiesImprovement_whatWasFound) {
        this.errors["evaluation_opportunitiesImprovement_whatWasFound"] = ["required"];
      }
      if (!this.improvement.evaluation_opportunitiesImprovement_whereWasFound) {
        this.errors["evaluation_opportunitiesImprovement_whereWasFound"] = ["required"];
      }
      if (!this.nodesToImprove?.length) {
        this.errors["nodesToImprove"] = ["required"];
      }
      return Object.keys(this.errors).length === 0;
    },
    saveImprovement() {
      if(this.hasRequiredFields()) {
        this.improvement.nodesToImprove = this.nodesToImprove;
        this.improvement.details = true;
        if (this.indexImprovement === -1) {
          let valuesToPush = { improvements: this.improvement };

          this.$store.dispatch("updateEvaluation", { valuesToPush });
        } else {
          let basePath = `improvements.${this.indexImprovement}`;
          let valuesToUpdate = {};
          Object.keys(this.improvement).map((key) => {
            valuesToUpdate[`${basePath}.${key}`] = this.improvement[key];
          });

          this.$store.dispatch("updateEvaluation", { valuesToUpdate });
        }
        this.improvement = {...{}};
        this.indexImprovement = -1;
        this.nodesToImprove = [...[]];
        this.newImprovement = false;
        this.$store.dispatch("getEvaluation");
      }
    },
    setImprovementDetails(improvementE) {
      if (improvementE.details === true) {
        improvementE.details = false;
      } else {
        improvementE.details = true;
      }
      this.$forceUpdate();
    },
    getNewTree() {
      var vm = this;

      function _dfs(oldNode) {
        var newNode = {};

        for (var k in oldNode) {
          if (k !== "children" && k !== "parent") {
            newNode[k] = oldNode[k];
          }
        }

        if (oldNode.children && oldNode.children.length > 0) {
          newNode.children = [];
          for (var i = 0, len = oldNode.children.length; i < len; i++) {
            newNode.children.push(_dfs(oldNode.children[i]));
          }
        }
        return newNode;
      }

      vm.newTree = _dfs(vm.data);
      return vm.newTree;
    },
    async treeSelection() {
      const tree = this.getNewTree();
      this.nodesToImprove = null;
      this.nodesToImprove = [...[]];
      this.extractImprovementRequired(tree);
    },
    extractImprovementRequired(node) {
      if (node.improvementRequired === true) {
        // eslint-disable-next-line camelcase
        const nodeToImprove = { ...node };
        delete nodeToImprove["children"];
        delete nodeToImprove["improvementRequired"];
        this.nodesToImprove.push(nodeToImprove);
      }
      if (node.children && node.children.length > 0) {
        node.children.map((child) => {
          this.extractImprovementRequired(child);
        });
      }
    },
    removeAllSelected(node) {
      node.improvementRequired = false;
      if (node.children && node.children.length > 0) {
        node.children.map((child) => {
          this.removeAllSelected(child);
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../../assets/css/variables";

.vtl-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &.vtl-menu-icon {
    margin-right: 4px;
    &:hover {
      color: inherit;
    }
  }
  &:hover {
    color: blue;
  }
}
.vtl-icon-caret-down:before {
  content: "\e901";
}
.vtl-icon-caret-right:before {
  content: "\e900";
}
.medium-title{
  text-align: center;
  font-size: 20px;
  font-family: $font-subtitle;
  text-transform: uppercase;
  }
</style>
